import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageIbiza = props => {
  return <CityLandingPage cityKey="Ibiza" cityConfig={cityContent.ibiza} {...props} />;
};

export default LandingPageIbiza;
